import { SupplierCompanyItem } from "shared/api";
import { AdaptedStatuses } from "shared/types";

export const adaptCompanies = (companiesAdapted: SupplierCompanyItem[]) => {
  const adaptCompanies = companiesAdapted?.map((item) => ({
    label: `${item.name}`,
    value: item.id!,
  }));
  return adaptCompanies || [];
};

export const adaptIncoTermsToOptions = (
  incoTerms: string[]
): AdaptedStatuses[] =>
  incoTerms?.map((term) => ({ label: term, value: term })) || [];

export const adaptByersCompanies = (
  companiesAdapted: SupplierCompanyItem[]
) => {
  const adaptCompanies = companiesAdapted
    ?.filter((item) => item?.is_buyer)
    .map((item) => ({
      label: `${item.name}`,
      value: item.id!,
    }));
  return adaptCompanies || [];
};
